import { GridFilterModel } from '@mui/x-data-grid';

export function parseFilterModel(filterModel: GridFilterModel) {
    const conditions: unknown[] = [];
    filterModel.items.forEach((item) => {
        const field = item.field;
        const operator = item.operator;
        const value = item.value;

        switch (field) {
            case 'testroomName':
                conditions.push({
                    testroomName: {
                        [operator]: value,
                    },
                });
                break;
            case 'classes':
                conditions.push({
                    class: {
                        some: {
                            className: {
                                [operator]: value,
                            },
                        },
                    },
                });
                break;
            case 'schoolYear':
                conditions.push({
                    class: {
                        schoolYear: {
                            [operator]: value,
                        },
                    },
                });
                break;
            case 'lessonName':
                conditions.push({
                    lessonVersion: {
                        lessonName: {
                            [operator]: value,
                        },
                    },
                });
                break;
        }
    });

    return conditions;
}
